module.exports = __webpack_public_path__ + "static/media/Milos_Sarakiniko_me.3a1a76e4.jpeg";